import { render, staticRenderFns } from "./ScoreboardApp.vue?vue&type=template&id=b149467c&"
import script from "./ScoreboardApp.vue?vue&type=script&lang=js&"
export * from "./ScoreboardApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports